import React from 'react';

export default function TermsOfServices() {
    return (
      <main style={{ padding: "1rem 0" }}>
        <h2>Termos de serviço</h2>
        <embed src="../../assets/contracts/terms_of_service.txt"/>
      </main>
    );
  }


// WEBPACK FOOTER //
// ./src/routes/terms_of_service.js